<template>
  <modal-gestor :opened="opened" no-pad="true" width="medium">
    <div aria-live="polite" class="p-3 pedidos-body">
      <div v-if="carregandoStatus" class="status-loading">
        <loading text="Consultando status..."/>
      </div>
      <template v-else>
      <div v-if="!isUairango" class="d-flex align-items-center mb-3">
        <div>
          <img v-if="logo" :alt="nome" :src="logo" class="integracao-logo mr-2">
          <span class="d-none d-md-inline-block">Status da Integração</span>
        </div>
        <button v-if="menu === 1" :disabled="carregandoStatus" aria-label="Sincronizar status de todas as lojas" class="btn btn-gray btn-sm text-info ml-auto" title="Sincronizar status" @click="buscarStatus(contas)">
          <i aria-hidden="true" class="fa fa-sync-alt mr-1"></i> Sincronizar
        </button>
      </div>
      <modal-menu v-if="isUairango" :menus="menus" :selected="menu" @changeMenu="trocarMenu"/>

      <section v-if="menu === 1">
        <div v-for="(conta, index) in contas" :key="conta.id_auth || index" class="card mb-2 text-left">
          <div class="card-body conexao-info">
            <div v-if="conta.erro" class="alert alert-danger mb-0" role="alert">{{ conta.erro }}</div>
            <template v-else-if="conta.status">
              <h6 class="font-weight-bold mb-0 small">{{ conta.nome_conexao || conta.nome_fantasia }}</h6>
              <div :class="{'text-success': conta.status.store_status === 'open', 'text-danger': conta.status.store_status === 'closed', 'text-muted': conta.status.store_status === 'unknown'}" class="font-weight-bold conexao-nome">{{ conta.status.message.title || (conta.status.store_status === 'open' ? 'Loja aberta' : conta.status.store_status === 'closed' ? 'Loja fechada' : 'Status da loja') }}</div>
              <div v-if="descricaoStatus(conta.status)" class="small">{{ descricaoStatus(conta.status) }}</div>
            </template>
            <div v-else class="text-muted">Status não disponível.</div>
          </div>
        </div>
      </section>
      <section v-if="isUairango && menu === 2">
        <div class="row no-gutters align-items-start">
          <div class="col-md p-1">
            <select id="integracaoPedidos" v-model="contaSelecionada" :disabled="importando !== null" aria-label="Integração" class="form-control mb-3" @change="selecionarConta">
              <option v-for="(conta, index) in contas" :key="conta.id_auth || index" :value="index">{{ rotuloConta(conta, index) }}</option>
            </select>
          </div>
          <div class="col-md p-1">
            <select id="statusPedidos" v-model="statusPedidos" :disabled="ocupado" aria-label="Status dos pedidos" class="form-control mb-3" @change="selecionarConta">
              <option value="">Todos</option>
              <option value="pending">Pendentes</option>
              <option value="approved">Aprovados</option>
              <option value="canceled">Cancelados</option>
            </select>
          </div>
          <div v-if="apiDisponivel" class="col-md-auto p-1 mb-3">
            <button :disabled="ocupado" class="btn btn-warning" @click="buscar()">
              <i aria-hidden="true" class="fa fa-sync-alt mr-1"></i> Atualizar
            </button>
          </div>
        </div>
        <div v-if="!apiDisponivel" class="alert alert-info mb-0">A busca e a importação de pedidos estarão disponíveis em breve.</div>
        <template v-else>
          <div v-if="erro" class="alert alert-danger" role="alert">{{ erro }}</div>
          <div v-if="mensagem" class="alert alert-success">{{ mensagem }}</div>
          <loading v-if="carregando" class="pt-4 pb-5" text="Buscando pedidos..."/>
          <div v-else-if="buscou && !erro && !pedidos.length" class="text-center text-muted py-4">Nenhum pedido encontrado nesta integração.</div>
          <div v-for="pedido in pedidos" v-show="!carregando" :key="pedido.external_order_id" class="card mb-2">
            <div class="card-body p-2 d-flex justify-content-between align-items-center">
              <div class="pr-2 pedido-info">
                <div class="font-weight-bold">Pedido #{{ pedido.external_order_id }}</div>
                <div v-if="pedido.created_at" class="small text-muted">{{ $dayjs(pedido.created_at).format('DD/MM/YYYY - HH:mm') }}</div>
                <div class="small">
                  <span v-if="pedido.status_label" :class="{'badge-warning': pedido.status === 'pending', 'badge-success': pedido.status === 'approved', 'badge-danger': pedido.status === 'canceled', 'badge-secondary': !['pending', 'approved', 'canceled'].includes(pedido.status)}" class="badge">{{ pedido.status_label }}</span>
                  <span v-if="pedido.total != null" class="ml-1">{{ pedido.total | valor }}</span>
                </div>
              </div>
              <div class="text-right">
                <span v-if="pedido.import_status === 'imported'" aria-label="Pedido importado" class="text-success mr-2" title="Importado">
                  <i aria-hidden="true" class="fa fa-check"></i>
                </span>
                <span v-else-if="pedido.import_status === 'error'" class="badge badge-danger">Falha na importação</span>
                <span v-else-if="pedido.import_status === 'discarded'" class="badge badge-secondary">Descartado</span>
                <button v-if="pedido.import_status !== 'imported'" :disabled="ocupado || pedido.can_import !== true" aria-label="Importar pedido" class="btn btn-primary btn-sm px-3 ml-2" title="Importar pedido" @click="importar(pedido)">
                  <i :class="importando === pedido.external_order_id ? 'fa fa-spinner fa-spin' : 'fa fa-download'" aria-hidden="true"></i>
                </button>
                <div v-if="pedido.error_message" class="small text-danger mt-1">{{ pedido.error_message }}</div>
              </div>
            </div>
            <div v-if="pedido.can_import !== true && pedido.import_block_reason" class="card-footer p-1 small text-muted text-center">
              <i aria-hidden="true" class="fa fa-exclamation-circle mr-1"></i>{{ motivoBloqueio(pedido.import_block_reason) }}
            </div>
          </div>
          <div v-if="buscou && !carregando && !ocupado && (skipPedidos > 0 || pedidos.length >= 50)" class="d-flex justify-content-between align-items-center border-top pt-3 mt-3">
            <button :disabled="ocupado || skipPedidos === 0" class="btn btn-gray btn-sm" @click="buscar(Math.max(0, skipPedidos - 50))">Anterior</button>
            <span class="small">Página {{ Math.floor(skipPedidos / 50) + 1 }}</span>
            <button :disabled="ocupado || pedidos.length < 50" class="btn btn-gray btn-sm" @click="buscar(skipPedidos + 50)">Próxima</button>
          </div>
        </template>
      </section>
      </template>
    </div>
    <div class="border-top p-3 text-center">
      <button :disabled="importando !== null" class="btn btn-dark px-4" @click="fechar">Fechar</button>
    </div>
  </modal-gestor>
</template>

<script>
import ModalGestor from '../gestor/ModalGestor';
import ModalMenu from './ModalMenu';
import Loading from './Loading';
import api from '@/services/pedidosIntegracoes';

export default {
  name: 'ModalIntegracao',
  components: { ModalGestor, ModalMenu, Loading },
  data() {
    return { opened: false, contas: [], contaSelecionada: 0, menu: 1, sessao: 0, nome: '', pedidos: [], carregando: false,
      statusPedidos: '', skipPedidos: 0, importando: null, erro: '', mensagem: '', buscou: false, buscaId: 0 };
  },
  computed: {
    carregandoStatus() { return this.contas.some(conta => conta.carregando); },
    integracao() { return this.contas[this.contaSelecionada] || null; },
    menus() { return [{ nome: 'Dados', active: true }, { nome: 'Pedidos', active: this.isUairango }]; },
    plataforma() { return this.integracao ? String(this.integracao.plataforma) : ''; },
    isUairango() { return this.plataforma === '4'; },
    logo() {
      const logos = {
        '2': require('@/assets/icons/ifood.svg'),
        '4': require('@/assets/icons/uairango.svg'),
        '16': require('@/assets/icons/aiqfome.svg'),
        '18': require('@/assets/icons/99food.png')
      };
      return logos[this.plataforma];
    },
    apiDisponivel() { return this.isUairango && api.disponivel; },
    ocupado() { return this.carregando || this.importando !== null; }
  },
  beforeDestroy() { this.buscaId++; this.sessao++; },
  methods: {
    motivoBloqueio(motivo) {
      return {
        already_imported: 'Pedido já importado.',
        already_processing: 'Importação em processamento.',
        order_not_pending: 'Pedido não está pendente.',
        order_older_than_20_minutes: 'Pedido com mais de 20 minutos.',
        invalid_order_date: 'Data do pedido inválida.'
      }[motivo] || 'Importação indisponível.';
    },
    descricaoStatus(status) {
      if (!status || !status.message) return '';
      const descricao = status.message.description;
      return descricao && descricao.trim() ? descricao : status.store_status === 'open' ? 'Pronto para receber pedidos.' : '';
    },
    rotuloConta(conta) {
      return [conta.nome_fantasia || this.nome, conta.nome_conexao].filter(Boolean).join(' · ');
    },
    async buscarStatus(contas) {
      const sessao = this.sessao;
      const pendentes = contas.filter(conta => !conta.carregando);
      pendentes.forEach(conta => {
        conta.erro = '';
        conta.status = null;
        conta.carregando = true;
      });
      const ids = [...new Set(pendentes.filter(conta => conta.id_auth).map(conta => String(conta.id_auth)))];
      pendentes.filter(conta => !conta.id_auth).forEach(conta => {
        conta.erro = 'Não foi possível identificar esta integração para consultar o status.';
        conta.carregando = false;
      });
      await Promise.all(Array.from({ length: Math.ceil(ids.length / 10) }, async (_, index) => {
        const lote = ids.slice(index * 10, index * 10 + 10);
        const contasLote = pendentes.filter(conta => lote.includes(String(conta.id_auth)));
        try {
          const response = await this.$http.get('v2/integracoes/status', { params: { id_auth: lote.join(',') } });
          if (sessao !== this.sessao) return;
          const data = response.data;
          if (!data || data.success !== true || !Array.isArray(data.integracoes)) {
            throw new Error(data && data.msg || 'Não foi possível consultar o status.');
          }
          contasLote.forEach(conta => {
            const resultado = data.integracoes.find(item => String(item.id_auth) === String(conta.id_auth));
            conta.nome_conexao = resultado && resultado.nome_conexao || null;
            if (resultado && Object.prototype.hasOwnProperty.call(resultado, 'nome_fantasia')) {
              conta.nome_fantasia = resultado.nome_fantasia;
            }
            if (resultado && resultado.success === true && resultado.status && resultado.status.message) {
              conta.status = resultado.status;
            } else {
              conta.erro = resultado && resultado.error && resultado.error.message || 'Não foi possível consultar o status desta integração.';
            }
          });
        } catch (e) {
          if (sessao !== this.sessao) return;
          const mensagem = e.data && e.data.msg || e.message || 'Não foi possível consultar o status. Tente atualizar novamente.';
          contasLote.forEach(conta => { conta.erro = mensagem; });
        } finally {
          if (sessao === this.sessao) contasLote.forEach(conta => { conta.carregando = false; });
        }
      }));
    },
    trocarMenu(menu) {
      if (this.importando !== null) return;
      this.menu = menu;
      if (menu === 2 && !this.buscou && !this.carregando && this.apiDisponivel) this.buscar();
    },
    selecionarConta() {
      this.buscaId++;
      this.carregando = false;
      this.pedidos = [];
      this.skipPedidos = 0;
      this.erro = '';
      this.mensagem = '';
      this.buscou = false;
      if (this.apiDisponivel) this.buscar();
    },
    open(integracoes, nome) {
      if (this.importando !== null) return;
      this.buscaId++;
      this.sessao++;
      this.contas = integracoes.map(conta => ({ ...conta, nome_conexao: conta.nome_conexao || null, nome_fantasia: conta.nome_fantasia || null, status: null, carregando: false, erro: '' }));
      this.contaSelecionada = 0;
      this.menu = 1;
      this.nome = nome;
      this.pedidos = [];
      this.statusPedidos = '';
      this.skipPedidos = 0;
      this.erro = '';
      this.mensagem = '';
      this.buscou = false;
      this.carregando = false;
      this.opened = true;
      this.buscarStatus(this.contas);
    },
    fechar() {
      if (this.importando !== null) return;
      this.buscaId++;
      this.sessao++;
      this.opened = false;
      this.carregando = false;
    },
    async buscar(skip = this.skipPedidos) {
      if (this.ocupado || !this.apiDisponivel) return;
      if (!this.integracao || !this.integracao.id_auth) {
        this.erro = 'Esta integração não possui uma autenticação válida.';
        return;
      }
      const buscaId = ++this.buscaId;
      this.carregando = true;
      this.erro = '';
      this.mensagem = '';
      try {
        const pedidos = await api.buscar({ http: this.$http, id_auth: this.integracao.id_auth, status: this.statusPedidos, skip, limit: 50 });
        if (buscaId !== this.buscaId) return;
        if (!Array.isArray(pedidos)) throw new Error('Resposta inválida ao buscar pedidos.');
        this.pedidos = pedidos;
        this.skipPedidos = skip;
        this.buscou = true;
      } catch (e) {
        if (buscaId === this.buscaId) this.erro = e.message || 'Não foi possível buscar os pedidos. Tente novamente.';
      } finally {
        if (buscaId === this.buscaId) this.carregando = false;
      }
    },
    async importar(pedido) {
      if (this.ocupado || !this.apiDisponivel || pedido.can_import !== true) return;
      this.importando = pedido.external_order_id;
      this.erro = '';
      this.mensagem = '';
      try {
        const resultado = await api.importar({ http: this.$http, id_auth: this.integracao.id_auth, pedido });
        Object.keys(resultado).filter(key => key !== 'success').forEach(key => this.$set(pedido, key, resultado[key]));
        this.$set(pedido, 'imported', resultado.import_status === 'imported');
        this.mensagem = resultado.import_status === 'imported' ? 'Pedido já importado no Lecard.' : '';
      } catch (e) {
        this.erro = e.message || 'Não foi possível solicitar a importação. Tente novamente.';
      } finally {
        this.importando = null;
      }
    }
  }
};
</script>

<style scoped>
.pedidos-body { max-height: calc(100vh - 230px); overflow-y: auto; }
.status-loading { height: 280px; display: flex; align-items: center; justify-content: center; }
.integracao-logo { width: 38px; height: 38px; object-fit: contain; flex-shrink: 0; }
.pedido-info { min-width: 0; overflow-wrap: anywhere; }
.conexao-nome { min-width: 0; overflow-wrap: anywhere; font-size: 16px; line-height: 1.3; }
.conexao-info { min-width: 0; overflow-wrap: anywhere; padding-top: 12px; padding-bottom: 12px }
</style>
